import React, { useEffect } from 'react';
import './../PerformanceCard.css'; // Assuming you will style the component similarly to TradeCard
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PerformanceCard = ({ performance, isDarkMode = false }) => {
    
    // useEffect(() => {
    //     console.log("PerformanceCard performance: ", performance.closeType);
    //   }, []);

    if (!performance) return null;

    const lotVariant = String(
      performance.lotVariant || performance.closing_order?.lotVariant || ''
    ).toUpperCase();
    const pnlNum = Number(performance.pnl) || 0;
    const pnlColor = pnlNum > 0 ? "green" : "red";
    const buySell = String(performance.buy_sell ?? '');
    const quantityColor = buySell === '1' ? 'green' : 'red';
    const quantityColor2 = buySell === '1' ? 'red' : 'green';

    return (
        <div className={`position-card ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <h4 className="position-scriptName">
                        {performance.stockName ?? '—'}
                        {lotVariant === 'MINI' && <span className="lot-variant-mini">MINI</span>}
                        &nbsp;
                        <span className='position-autocut'>
                            {`QTY : ${performance.orderQuantity ?? 0}`}
                        </span>
                    </h4>
                </div>
                <div className="text-end">
                    <p className={`position-pnl ${pnlColor}`}>₹{ pnlNum.toFixed(2) }</p>
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center" style={{marginTop:'3px'}}>
                <div>
                    <span className={`position-quantity ${quantityColor2}`}>
                        {buySell === '2' ? `Buy Avg. @ ${Number(performance.entryPrice || 0).toFixed(2)}` : `Sell Avg. @ ${Number(performance.entryPrice || 0).toFixed(2)}`}
                    </span>
                </div>
                <div>
                    {/* <p className='position-dateTime'>Autocut: {new Date(position.autoCutDate).toLocaleString()}</p> */}
                    <span className={`position-quantity ${quantityColor}`} style={{marginLeft:'10px', marginRight:'0px'}}>
                        {/* {performance.buy_sell === '1' ? `Buy:${performance.orderQuantity}` : `Sell:-${performance.orderQuantity}`} */}
                        {buySell === '1' ? `Buy @ ${Number(performance.orderPrice || 0).toFixed(2)}` : `Sell @ ${Number(performance.orderPrice || 0).toFixed(2)}`}
                    </span>
                    { String(performance.closeType) === '1' && <span className="position-market" style={{color:'#ff0000'}} >Auto Exit</span> }
                    {String(performance.orderType || '1') !== '1' && <span className="position-market" >
                        {/* {performance.orderType === '1' ? `MARKET` : (performance.orderType === '2' ? `LIMIT` : `SL`)} */}
                        { String(performance.orderType) === '2' ? `LIMIT` : `SL` }
                        
                    </span>}
                </div>
            </div>
            {/* <div className="d-flex justify-content-between align-items-center" style={{marginTop:'5px'}}>
                <span className='position-autocut'>
                    {performance.exeDateTime}
                </span>
                <span className='position-autocut'>
                    {performance.closing_order.exeDateTime}
                </span>
            </div> */}
            
        </div>
    );
}

export default PerformanceCard;
